export default __webpack_public_path__ + "static/media/front-end-tools.6c7752f1.png";